import { render, staticRenderFns } from "./InsLatestNews.vue?vue&type=template&id=111bcf29&scoped=true"
import script from "./InsLatestNews.vue?vue&type=script&lang=ts"
export * from "./InsLatestNews.vue?vue&type=script&lang=ts"
import style0 from "./InsLatestNews.vue?vue&type=style&index=0&id=111bcf29&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111bcf29",
  null
  
)

export default component.exports